module.exports = __webpack_public_path__ + "static/img/pypt.cbf34b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/appModule/bouncedMormApp/img/pypt.jpg
// module id = q2GN
// module chunks = 1